<div
    class="generic-radio-button form-check button-{{ buttonStyle }}"
    [class.flew-wrap]="isFlexWrapContainer"
    (click)="radioButtonChecked.click()">
    <div class="button-container">
        <input
            (change)="toggleRadioButton(value)"
            (click)="$event.stopPropagation()"
            class="form-check-input"
            [formControl]="control"
            [id]="id"
            [name]="name"
            type="radio"
            [value]="value"
            [attr.data-testid]="dataTestId"
            [attr.aria-labelledby]="labelledById"
            [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
            #radioButtonChecked />
        @if (isCollapsible) {
        <button [attr.aria-expanded]="radioButtonChecked.checked" [attr.aria-label]="label" disabled></button>
        } @if (radioButtonChecked.checked) {
        <div class="inner-circle"></div>
        }
    </div>
    <div class="label-content">
        <label class="label-{{ labelStyle }} label" [for]="id">
            @if (label) {
            <span>{{ label }}</span>
            } @else {

            <ng-content select="[labelContent]"></ng-content>

            }
            <ng-template #labelContent>
                <ng-content select="[labelContent]"></ng-content>
            </ng-template>
            @if (describe) {
            <span hSrOnlyNoSnippet>{{ describe }}</span>
            }
        </label>
        <div class="sub-label label">
            <ng-content select="[subLabel]"></ng-content>
        </div>
    </div>
    <div class="right-content">
        <ng-content select="[rightContent]"></ng-content>
    </div>
</div>
<div
    [class.radio-checked]="radioButtonChecked?.checked"
    class="radio-button-separator"
    [@expandCollapseAnimation]="{
        value: isCollapsible && radioButtonChecked.checked ? 'open' : 'closed',
        params: { duration: animationDuration }
    }"
    [@.disabled]="isAnimationDisabled"
    (@expandCollapseAnimation.done)="scrollToView($event)">
    @if (hasSeparator) {
    <h-separator [isFullLength]="false" [lightColor]="false"></h-separator>
    }
    <ng-content></ng-content>
</div>
@if (hasSeparator) {
<h-separator [isFullLength]="true" [lightColor]="true"></h-separator>
}
